import { Codebook } from '../Codebook'
import { $t } from '../../composables/i18n'

export enum ThemeId {
  DEFAULT = 1,
  DARK,
  ORANGE,
  RED,
  GREEN,
  GRAY,
  BORDO,
  BROWN,
  PURPLE,
  DARKBLUE,
  BLACK,
  DARKBROWN,
  LIGHTORANGE,
  DARKGREEN,
  LIGHTGREEN,
  WINE,
  VIOLET,
  PINK,
  DARKPINK,
  NATUREGREEN,
  GOLD,
  DARKMODE_GOLD,
  DARKMODE_CYAN,
  DARKMODE_GRAY,
  DARKMODE_PINK,
  DARKMODE_BLUE,
  DARKMODE_ORANGE,
  DARKMODE_GREEN,
}

export class Theme extends Codebook<ThemeId> {
  private constructor(
    id: ThemeId,
    public readonly name: () => string,
    public readonly color: string,
  ) {
    super(id)
  }

  static readonly DEFAULT = new Theme(ThemeId.DEFAULT, () => $t('Default'), '#1991EB')
  static readonly DARK = new Theme(ThemeId.DARK, () => $t('Dark'), '#393939')
  static readonly ORANGE = new Theme(ThemeId.ORANGE, () => $t('Orange'), '#F43D00')
  static readonly RED = new Theme(ThemeId.RED, () => $t('Red'), '#C50000')
  static readonly GREEN = new Theme(ThemeId.GREEN, () => $t('Green'), '#368636')
  static readonly GRAY = new Theme(ThemeId.GRAY, () => $t('Gray'), '#333')
  static readonly BORDO = new Theme(ThemeId.BORDO, () => $t('Bordo'), '#9F0A06')
  static readonly BROWN = new Theme(ThemeId.BROWN, () => $t('Brown'), '#A3875E')
  static readonly PURPLE = new Theme(ThemeId.PURPLE, () => $t('Purple'), '#95596B')
  static readonly DARKBLUE = new Theme(ThemeId.DARKBLUE, () => $t('Darkblue'), '#516485')
  static readonly BLACK = new Theme(ThemeId.BLACK, () => $t('Black'), '#1D1D1D')
  static readonly DARKBROWN = new Theme(ThemeId.DARKBROWN, () => $t('Darkbrown'), '#342216')
  static readonly LIGHTORANGE = new Theme(ThemeId.LIGHTORANGE, () => $t('Lightorange'), '#FB7600')
  static readonly DARKGREEN = new Theme(ThemeId.DARKGREEN, () => $t('Darkgreen'), '#10580E')
  static readonly LIGHTGREEN = new Theme(ThemeId.LIGHTGREEN, () => $t('Lightgreen'), '#76B38F')
  static readonly WINE = new Theme(ThemeId.WINE, () => $t('Wine'), '#7C122C')
  static readonly VIOLET = new Theme(ThemeId.VIOLET, () => $t('Violet'), '#6A3B8A')
  static readonly PINK = new Theme(ThemeId.PINK, () => $t('Pink'), '#D11977')
  static readonly DARKPINK = new Theme(ThemeId.DARKPINK, () => $t('Darkpink'), '#EE0A3F')
  static readonly NATUREGREEN = new Theme(ThemeId.NATUREGREEN, () => $t('Naturegreen'), '#ACC02B')
  static readonly GOLD = new Theme(ThemeId.GOLD, () => $t('Gold'), '#E8A32F')

  static readonly DARKMODE_GOLD = new Theme(
    ThemeId.DARKMODE_GOLD,
    () => $t('Dark mode gold'),
    '#E8B774',
  )
  static readonly DARKMODE_CYAN = new Theme(
    ThemeId.DARKMODE_CYAN,
    () => $t('Dark mode cyan'),
    '#15A7B8',
  )
  static readonly DARKMODE_GRAY = new Theme(
    ThemeId.DARKMODE_GRAY,
    () => $t('Dark mode gray'),
    '#979797',
  )
  static readonly DARKMODE_PINK = new Theme(
    ThemeId.DARKMODE_PINK,
    () => $t('Dark mode pink'),
    '#FC387B',
  )
  static readonly DARKMODE_BLUE = new Theme(
    ThemeId.DARKMODE_BLUE,
    () => $t('Dark mode blue'),
    '#30A6FF',
  )
  static readonly DARKMODE_ORANGE = new Theme(
    ThemeId.DARKMODE_ORANGE,
    () => $t('Dark mode orange'),
    '#E88A2C',
  )
  static readonly DARKMODE_GREEN = new Theme(
    ThemeId.DARKMODE_GREEN,
    () => $t('Dark mode green'),
    '#0FC896',
  )
}
